const MAX_ISSUE_ID = 2_147_483_647;

/**
 * The issue a `?selected=` deep link names, or null for an absent, empty or
 * malformed value (a truncated or hand-edited link), which would otherwise
 * reach the store as `NaN` or out of range and fail its read. A malformed one
 * is not silent: `useOpenIssueDeepLink` reports it as a link that failed.
 */
export function selectedIssueParam(searchParams: URLSearchParams): number | null {
  const raw = searchParams.get("selected");
  if (!raw || !/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  // Issue ids are Postgres `integer`; a larger one fails the read out of range.
  return id > 0 && id <= MAX_ISSUE_ID ? id : null;
}
